export default __webpack_public_path__ + "static/media/scale_chiller_tubes_resized_0.be9283b8.jpg";